module.exports = {
    "Empty": `Tom`
};


//# sourceMappingURL=da-DK.main.js.map
